import { useEffect, useState } from 'react';

const TournamentBlindLevelCard = ({
  running,
  levelEndAt,
  currentLevel,
}: {
  running: boolean;
  levelEndAt?: Date | null;
  currentLevel: number;
}) => {
  // Countdown logic
  const getRemainingSeconds = () => {
    if (!levelEndAt) return 0;
    const now = new Date();
    const diff = Math.max(0, Math.floor((new Date(levelEndAt).getTime() - now.getTime()) / 1000));
    return diff;
  };

  const [remainingSeconds, setRemainingSeconds] = useState(getRemainingSeconds());

  useEffect(() => {
    setRemainingSeconds(getRemainingSeconds());

    if (!levelEndAt) return;

    const interval = setInterval(() => {
      setRemainingSeconds(getRemainingSeconds());
    }, 1000);

    if (!running) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [levelEndAt, running]);

  const pad = (num: number) => String(num).padStart(2, '0');
  const formatSeconds = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  return (
    <div className="d-flex align-items-center justify-content-start gap-2">
      <h4 className="mb-0 text-lg">Level {currentLevel}</h4>
      <span>-</span>
      <h4 className="font-nunito mb-0 text-sm font-bold" aria-label="Countdown timer">
        {formatSeconds(remainingSeconds)}
      </h4>
    </div>
  );
};

export default TournamentBlindLevelCard;
